<ion-app>
    <ion-split-pane contentId="main-content">
        @if (authService.isAuthenticated()) {
            <ion-menu menuId="sideMenu" contentId="main-content">
                <ion-header>
                    <ion-toolbar>
                        <!-- <ion-title text-center>{{vm.dealershipName}}</ion-title><br />
                        Welcome Back {{vm.firstName}} -->
                        <ion-item color="secondary" class="ion-text-center">
                        <ion-label>
                            <!-- <span style="float: center">{{vm.dealershipName}}</span><br />
                            <span style="float: center">Welcome Back {{vm.firstName}}</span> -->

                            {{vm.dealershipName}}<br />
                            Welcome Back {{vm.firstName}}

                            <!-- <ion-text class="ion-text-center">{{vm.dealershipName}}</ion-text><br />
                            <ion-text class="ion-text-center">Welcome Back {{vm.firstName}}</ion-text> -->

                        </ion-label>
                        </ion-item>
                    </ion-toolbar>
                </ion-header>

                <ion-content>
                    <ion-list>
                        @for (p of appPages; track $index) {
                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'" (click)="onMenuItemClick(p)"
                                [class.active-item]="selectedRouteUrl.startsWith(p.url)">
                                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                                <ion-label>
                                    {{p.title}}
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                        }
                    </ion-list>
                </ion-content>
            </ion-menu>
        }

        <!-- The specific page will be rendered in the main content area. -->
        <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>
